import {useSearchParams} from 'react-router-dom';
import {useKioskoStore} from '../useKioskoStore';

export const useKioskoConnectionStatus = () => {
  const isConnected = useKioskoStore(state => state.connection.isConnected);
  const hasCompletedInitialization = useKioskoStore(
    state => state.connection.hasCompletedInitialization,
  );
  const [searchParams] = useSearchParams();
  const isAttempted = searchParams.get('layout') === 'kiosko';

  return {isConnected, hasCompletedInitialization, isAttempted};
};
